import {buildHeaders, generateUrl, generateUrlApiV2, getHostname} from '../helpers/MiddlewareHelpers';
import axios from 'axios';

const trackSessionApiCall = (idCompetition, parameters, successCallback, catchCallback) => {

  const headers = buildHeaders();
  const url = generateUrlApiV2(`/event/${idCompetition}`);

  axios.post(url, parameters, {
    method: 'POST',
    crossdomain: true,
    headers: headers
  })
    .then(successCallback)
    .catch(catchCallback);
}

const trackVoteApiCall = (idCompetition, parameters, successCallback, catchCallback) => {

  const headers = buildHeaders();
  const url = generateUrlApiV2(`/event/${idCompetition}`);

  axios.post(url, parameters, {
    method: 'POST',
    crossdomain: true,
    headers: headers
  })
    .then(successCallback)
    .catch(catchCallback);
}

const trackOptinApiCall = (idCompetition, parameters, successCallback, catchCallback) => {

  const headers = buildHeaders();
  const url = generateUrlApiV2(`/event/${idCompetition}`);

  axios.post(url, parameters, {
    method: 'POST',
    crossdomain: true,
    headers: headers
  })
    .then(successCallback)
    .catch(catchCallback);
}

const loadCompetitionApiCall = (parameters, successCallback, catchCallback) => {

  const headers = buildHeaders();
  const url = generateUrlApiV2(`/competition/hash/${parameters.hash.replace(/\//g, "_")}`);

  axios.get(url, {
    method: 'GET',
    crossdomain: true,
    headers: headers
  })
    .then(successCallback)
    .catch(catchCallback);
}

const submitApiCall = (parameters, successCallback, catchCallback) => {

  const headers = buildHeaders();
  // const url = generateUrl('/vote/teampicker');
  const url = generateUrlApiV2(`/competition/vote-teampicker`);

  axios.post(url, parameters, {
    method: 'POST',
    crossdomain: true,
    headers: headers
  })
    .then(successCallback)
    .catch(catchCallback);
}

const optinApiCall = (parameters, successCallback, catchCallback) => {

  const headers = buildHeaders();
  const url = generateUrlApiV2(`/competition/${parameters.idCompetition}/optin`);

  axios.post(url, parameters, {
    method: 'POST',
    crossdomain: true,
    headers: headers
  })
    .then(successCallback)
    .catch(catchCallback);
}

const getStatisticsForCompetition = (idCompetition, successCallback, catchCallback) => {
  const headers = buildHeaders();
  const url = generateUrl('/competition/statistics/teampicker/' + idCompetition);

  axios.get(url, {
    method: 'GET',
    crossdomain: true,
    headers: headers
  })
    .then(successCallback)
    .catch(catchCallback);
}

const getLanguageApiCall = (language,successCallback, catchCallback) => {
  const headers = buildHeaders();
  const url = generateUrlApiV2('/locale/getLocaleData/'+language);
  axios.get(url, {
    method: 'GET',
    crossdomain: true,
    headers: headers
  })
    .then(successCallback)
    .catch(catchCallback);
}

const renderShareApiCall = (parameters, successCallback, catchCallback) => {

  const headers = buildHeaders();
  const url = generateUrlApiV2(`/competition/renderShareForComp/${parameters.idCompetition}`);

  axios.post(url, parameters, {
    method: 'POST',
    crossdomain: true,
    headers: headers,
    data: {
      idVote: parameters.idVote
    }
  })
    .then(successCallback)
    .catch(catchCallback);
}

const dynamicRenderApiCall = (parameters, successCallback, catchCallback) => {

  const headers = buildHeaders();
  const url = generateUrlApiV2('/dynamic-render');
  // const url = generateUrl('/vote/dynamic-render');
  axios.post(url, parameters, {
    method: 'POST',
    crossdomain: true,
    headers,
  })
    .then(successCallback)
    .catch(catchCallback);
}

const webhookRegisterApi = (parameters, successCallback, catchCallback) => {

  const headers = buildHeaders();
  const url = generateUrlApiV2(`/competition/${parameters.idCompetition}/registerWebhook`);

  axios.post(url, parameters, {
    method: 'POST',
    crossdomain: true,
    headers: headers,
  })
    .then(successCallback)
    .catch(catchCallback);
}

const getGlobalScriptsForCustomerApi = (hash, successCallback, catchCallback) => {
  const headers = buildHeaders();
  const url = generateUrlApiV2(`/customer/getCodeInjectionForCustomer/${hash.replace(/\//g, "_")}`);
  axios.get(url, {
    method: 'GET',
    crossdomain: true,
    headers: headers
  })
    .then(successCallback)
    .catch(catchCallback);
}

const updateVBPInnerApi = (idCompetition, data, successCallback, catchCallback) => {
    const headers = buildHeaders();
    const url = generateUrlApiV2(`/competition/${idCompetition}/optinVB`);
    axios.post(url, data, {
      method: 'POST',
      crossdomain: true,
      headers: headers
    })
      .then(successCallback)
      .catch(catchCallback);
}

export {
  loadCompetitionApiCall, submitApiCall, optinApiCall, webhookRegisterApi,
  getStatisticsForCompetition, trackSessionApiCall, trackVoteApiCall,
  trackOptinApiCall,getLanguageApiCall, renderShareApiCall, dynamicRenderApiCall,
  getGlobalScriptsForCustomerApi, updateVBPInnerApi
}
